import { render, staticRenderFns } from "./IndepentendEvaluation.vue?vue&type=template&id=b4790be8&scoped=true"
import script from "./IndepentendEvaluation.vue?vue&type=script&lang=js"
export * from "./IndepentendEvaluation.vue?vue&type=script&lang=js"
import style0 from "./IndepentendEvaluation.vue?vue&type=style&index=0&id=b4790be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4790be8",
  null
  
)

export default component.exports